class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.isOpen = false;        
    this.setupEventListeners();
  }

  setupEventListeners() {
    const form = this.querySelector('form.search');
    form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {      
      this.onChange(event);
    }, 300).bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));    
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.close(true);
      return;
    }

    //this.getSearchResults(searchTerm);    
    this.getNostoSearchResults(searchTerm, nostoSearchSessionParams);    
  }
  
  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) return;

    if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      //this.getSearchResults(searchTerm);
      this.getNostoSearchResults(searchTerm, nostoSearchSessionParams);    
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up')
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault();
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allElements = this.querySelectorAll('li');
    let activeElement = this.querySelector('li');

    if (moveUp && !selectedElement) return;

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElement = selectedElement.nextElementSibling || allElements[0];
    } else if (moveUp) {
      activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
    }

    if (activeElement === selectedElement) return;

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.setLiveRegionText(activeElement.textContent);
    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');

    if (selectedProduct) selectedProduct.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    const types = ['product', 'collection', 'page', 'article'];
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=${encodeURIComponent(types)}&${encodeURIComponent('resources[limit]')}=4&resources[options][fields]=title,product_type,tag,variants.title&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        //console.log('predictive_search response')
        //console.log(response)

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

        //console.log('resultsMarkup')
        //console.log(resultsMarkup)

        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        this.close();
        throw error;
      });      
  }


  getNostoSearchResults(searchTerm, sessionParams) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    

      fetch('https://search.nosto.com/v1/graphql', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          query: `query ($query: String, $sessionParams: InputSearchQuery) {
            search(
              accountId: "shopify-10561394"
              query: $query
              sessionParams: $sessionParams
              products: { size: 4 }
              keywords: { size: 2 }
            ) {
              products {
                fuzzy
                hits {
                  productId
                  name
                  url
                  thumbUrl
                  price
                  priceCurrencyCode
                }
                total
              }
              keywords {
                hits {
                  keyword
                  _redirect
                  _highlight {
                    keyword
                  }
                }
              }
              query
            }
          }`,
          variables: {
            query: searchTerm,
            sessionParams: sessionParams
          },
        }),
      })
      .then((res) => res.json())
      .then((result) => {
        //console.log('nosto result')
        //console.log(result)
        this.renderNostoSearchResults(result.data.search.products.hits, searchTerm, result.data.search.products.total)

        Nosto.migrateToShopifyMarket({
          productSectionElement: '.nosto-product-info',
          productTitleElement: '.product-card__title',
          productUrlElement: '.nosto-product-url',
          productHandleAttribute: 'x-nosto-handle',
          priceElement: '.price-item',
          listPriceElement: '.price-item',
        })

        if(result.data.search.products.fuzzy){ 
          document.getElementsByClassName('predictive-search__heading')[0].innerText = "Similar Products";
        } else {
          document.getElementsByClassName('predictive-search__heading')[0].innerText = "Products";
        }
        
        let resultProducts = [];  
        result.data.search.products.hits.forEach(el => {
          resultProducts.push({ productId: el.productId})
        })
  
        nostojs(api => {
          api.recordSearch(
            "autocomplete",
            {
              query: result.data.search.query,
            },
            {
              products: result.data.search.products
            },
            {
              isKeyword: false  
            }
          )
        })

        Array.from(document.getElementsByClassName('predictive-search__products')[0].getElementsByClassName('nosto-product-url')).forEach(el => {
          el.addEventListener('click', e => {
            nostojs(api => {
              api.recordSearchClick(
                "autocomplete", 
                { productId: e.currentTarget.id, url: e.currentTarget.href }
              )
            })
          })
        })
        
      })
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');
    
    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
  }

  renderNostoSearchResults(hits, searchTerm, total) {
    let html = ``;

    html += `<h2 id="Products" class="predictive-search__heading">Products</h2>`;
    html += `<ul class="collection__grid predictive-search__products flex flex--wrap list-unstyled" role="listbox" aria-labelledby="Products">`;
    hits.forEach(hit => {

      let title = hit.name; 
      let titleArr = hit.name.split(' - ');
      if(titleArr.length == 2){
        title = titleArr[0]
      } else if (titleArr.length > 2){
        title = titleArr[1];
      }

      html += `
        <li role="option" aria-selected="false" x-nosto-handle="${hit.url.split('/products/')[1]}" class="nosto-product-info">            
          <a href="${hit.url}?autocompleteclick=1" id="${hit.productId}" class="product-card product-card--wishlist nosto-product-url" role="group" aria-label="product" title="Navigate to product ${hit.name}">
            <div class="product-card__media container media media-ratio" style="--media-ratio:133.33333333333334%" data-appmate="">
              <div class="media--primary">
                <img src="${hit.thumbUrl}" width="66" alt="${hit.name}" />
              </div>
            </div>

            <div class="product-card__info">
              <div class="flex--column flex jcb flex--mobile">

                <div>
                  <h3 class="product-card__title link-styled">
                    ${title}
                  </h3>
                </div>
                <div class="price-rating__wrapper body-1">
                  <div id="price-predictive-search" class="price flex aic flex--wrap flex--gap" style="--flex-gap: 0 .5rem">
                    <span class="price-item price-item--regular" aria-label="Regular price">
                      $ ${hit.price} ${hit.priceCurrencyCode}
                    </span>
                  </div>
                </div>

              </div>

            </div>
          </a>
        </li>
      `
    });
    html += `</ul>`;


    html += `
    <div class="predictive-search__footer content--floating flex">
      <a href="javascript:void(0)" class="btn--clear-search btn btn--tertiary text-center">Clear</a>
      <a class="btn--search btn btn--primary text-center" href="/search?q=${searchTerm}">VIEW ${total}</a>
    </div>
    `


    this.predictiveSearchResults.innerHTML = html;
    this.setAttribute('results', true);

    //this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {    
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent.replace('Clear', ''));
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.getElementById('shopify-section-header').getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.predictiveSearchResults.style.display = 'block';
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
    document.body.classList.add('modal--open');          
    if(this.querySelector('.btn--clear-search')){
      this.querySelector('.btn--clear-search').addEventListener('click', () => {this.close(true)});
    }    
  }

  close(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }

    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false
    this.predictiveSearchResults.style.display = 'none';
    this.predictiveSearchResults.removeAttribute('style');

    this.isOpen = false;
    document.body.classList.remove('modal--open');      
  }          
}

customElements.define('predictive-search', PredictiveSearch);

//console.log('predictive search')